<section
  id="sign-up"
  class="inner-section"
>
  <img
    src="@/assets/images/logo.png"
    alt="Energy2Go logo"
    id="logo"
    class="energy2go-logo"
  />

  <div
    id="login-div"
    class="blue-background mb-3"
  >
    <h2 class="box-title">Acessar por email</h2>
    <div class="vue-template">
      <div class="error-container">
        <p
          v-if="message"
          class="errors"
        >
          <b v-text="message"></b>
        </p>

        <div
          v-if="errors.length"
          class="errors"
        >
          <ul>
            <li
              v-for="error in errors"
              class="p-1"
            >
              <div v-for="listOfErrors in error">
                <ol>
                  <li
                    v-for="keyError in listOfErrors"
                    v-text="$t(keyError)"
                  ></li>
                </ol>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <form class="py-2">
        <div class="ml-auto mx-auto form-group">
          <BaseInput
            id="email_registration_input"
            v-model="input.email"
            type="email"
            :placeholder="$t('sign_up.type_email')"
            wrapper-class="width-270"
          />
        </div>

        <div
          class="mb-2 mt-2 m-auto form-group"
          id="user_terms_control"
        >
          <div class="d-flex align-items-center">
            <input
              id="user_terms_checkbox"
              type="checkbox"
              v-model="input.userTerms"
            />
            <label
              for="user_terms_checkbox"
              class="ms-2"
            >
              <span v-text="$t('sign_up.agree_user_terms')"></span>
              <a
                class="terms-link"
                href="./policy.html"
                target="_blank"
              >
                <u v-text="$t('sign_up.user_terms')"></u>
              </a>
            </label>
          </div>
        </div>

        <BaseButton
          id="sign_up_button"
          variant="primary"
          unstyled
          block
          class="m-auto btn-lg mt-4 text-uppercase width-270"
          v-on:click="signUp"
        >
          {{ $t('sign_up.submit') }}
        </BaseButton>
      </form>
    </div>

    <div
      class="clearfix"
      id="account-options-social"
    >
      <p class="register-account text-center mt-2 mb-1">
        <router-link
          to="/login-social"
          v-text="$t('sign_up.already_have_social_account')"
        ></router-link>
      </p>
    </div>

    <div
      class="clearfix"
      id="account-options-code"
    >
      <p class="register-account text-center mt-1">
        <span>
          <span v-text="$t('login.login_with_code')"></span>
          <router-link
            to="/code-validation"
            v-text="$t('login.click_here')"
          ></router-link>
        </span>
      </p>
    </div>
  </div>

  <div class="footer-links">
    <a
      href="#"
      v-on:click.prevent="handleShowPriceTableModal(true)"
    >
      <font-awesome-icon
        icon="fa-solid fa-money-bill-alt"
        class="btn-icon-map"
      />
      <span>{{ $t('home.take.price_table') }}</span>
    </a>
  </div>

  <div class="footer-links">
    <router-link :to="{ path: `maps` }">
      <font-awesome-icon
        icon="fa-solid fa-map-location-dot"
        class="btn-icon-map"
      />
      <span>{{ $t('login.find_us') }}</span>
    </router-link>
  </div>

  <PriceTableModal
    v-if="showPriceTableModal"
    :showPriceTableModal="showPriceTableModal"
    @hidePriceTableModal="handleShowPriceTableModal(false)"
  ></PriceTableModal>

  <AppVersion class="app-version" />

  <a
    :href="$t('login.whatsapp_msg')"
    target="_blank"
  >
    <font-awesome-icon
      class="whatsapp-icon-fixed"
      :icon="{ prefix: 'fab', iconName: 'whatsapp' }"
      size="2x"
    />
  </a>
</section>
